import styled from "@emotion/styled";
import { translate } from "@kaltura/mediaspace-shared-utils";

interface SiteLogoProps {
    src: string;
}

export const SiteLogo = ({ src }: SiteLogoProps) => <StyledImage src={src} alt={translate("Site logo")} />;

export const StyledImage = styled("img")(({ theme }) => ({
    width: 48,
    height: 48,
    flexShrink: 0,
    borderRadius: theme.kaltura.shape.roundness2,
}));
